// extracted by mini-css-extract-plugin
export default {"button":"ButtonCo_button__chSNA"};